import { useMemo, useReducer } from 'react';
import { combineReducers } from 'redux';

import dirtyStates, { initialState as initialDirtyStates } from '../reducers/dirty-states';
import models, { initialState as initialModelsState } from '../reducers/models';
import { selectResourceForKey } from '../selectors';
import { FormProps, IncompleteDeclaration, OneFormReduxState, ValidationResults } from '../types';
import { processDefaultOptions, useCommonForm } from './common';

export const reducers = combineReducers({
	dirtyStates,
	models,
});

const useLocalForm = <FieldNames extends string>(
	dataKey: string,
	_declaration: IncompleteDeclaration<FieldNames>,
): FormProps<FieldNames> => {
	const [state, dispatch] = useReducer(reducers, {
		models: initialModelsState,
		dirtyStates: initialDirtyStates,
	});
	const selector = useMemo(() => selectResourceForKey(dataKey), [dataKey]);
	const memoizedState = useMemo(() => ({ form: state }), [state]);
	const resource = selector(memoizedState) as OneFormReduxState<FieldNames> & {
		validation: ValidationResults<FieldNames>;
	};
	const declaration = processDefaultOptions(_declaration);
	return useCommonForm(dataKey, declaration, resource, dispatch);
};

export default useLocalForm;
